import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const ProcesoCompletoIT = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/proceso-comercial-completo.pdf`;
  /*const pdfUrl = "/pdf/proceso-comercial-completo.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Proceso Comercial Completo</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Proceso Comercial Completo" />
      </Container>
    </>
  );
};

 export default ProcesoCompletoIT;
